import { FC } from "react";
export interface BrightDateIconProps {
  height?: number | string;
  width?: number | string;
  fill?: string;
  style?: React.CSSProperties;
}
export const BrightDateIcon: FC<BrightDateIconProps> = ({
  height = 24,
  width = 24,
  fill = "#000000",
  style = {},
}) => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 960.71 960.71"
      height={height}
      width={width}
      style={style}
    >
      <polygon
        fill="none"
        points="801.06 208.39 705.06 208.39 705.06 240.39 689.06 240.39 689.06 208.39 497.06 208.39 497.06 240.39 481.06 240.39 481.06 232.39 481.06 208.39 385.06 208.39 385.06 304.39 801.06 304.39 801.06 208.39"
      />
      <path
        fill="none"
        d="M369.06,483.89c-.18.28-.36.58-.52.9l-46.3,94c-2.3,4.8-6.8,8-12,8.8l-103.6,15.2c-6.5.9-9.1,9-4.4,13.6l74.9,73.2c3.8,3.6,5.5,8.9,4.6,14.1l-17.6,103.3c-1.1,6.5,5.7,11.5,11.6,8.4l92.5-48.8c4.7-2.5,10.2-2.5,14.9,0l92.6,48.8c5.9,3.1,12.7-1.9,11.6-8.4l-17.7-103.4c-.9-5.1.8-10.4,4.6-14.1l74.9-73.2c2.36-2.26,2.92-5.33,2.11-8h-182.2v-124.4Z"
      />
      <rect fill="none" x="385.06" y="320.29" width="416" height=".1" />
      <path
        fill="none"
        d="M769.06,400.39c-70.7,0-128,57.3-128,128s57.3,128,128,128,128-57.3,128-128-57.3-128-128-128ZM833.06,536.39h-72v-88h16v72h56v16Z"
      />
      <path
        fill={fill}
        d="M167.65,528.39h-48v-48c0-4.4-3.6-8-8-8s-8,3.6-8,8v48h-48c-4.4,0-8,3.6-8,8s3.6,8,8,8h48v48c0,4.4,3.6,8,8,8s8-3.6,8-8v-48h48c4.4,0,8-3.6,8-8s-3.6-8-8-8Z"
      />
      <path
        fill={fill}
        d="M151.65,408.39h64v64c0,4.4,3.6,8,8,8s8-3.6,8-8v-64h64c4.4,0,8-3.6,8-8s-3.6-8-8-8h-64v-64c0-4.4-3.6-8-8-8s-8,3.6-8,8v64h-64c-4.4,0-8,3.6-8,8s3.6,8,8,8Z"
      />
      <path
        fill="#666766"
        style={{ isolation: "isolate" } as React.CSSProperties}
        d="M385.06,320.39v271.9h202.87c-7.08-19.97-10.87-41.54-10.87-63.9,0-106,86-192,192-192,10.9,0,21.6,1,32,2.7v-18.7h-416Z"
      />
      <path
        fill={fill}
        d="M587.96,592.29h-202.9v-272h416v18.7c5.4.9,10.7,2,16,3.4v-150h-112v-64h-16v64h-192v-64.1h-16v64h-112v273.03c-6.09,1.74-11.58,5.89-14.82,12.47l-46.3,94-103.5,15.1c-19.7,2.9-27.5,27-13.3,40.9l74.9,73.2-17.7,103.3c-3.4,19.6,17.2,34.6,34.8,25.3l92.6-48.8,92.6,48.8c17.6,9.3,38.2-5.7,34.8-25.3l-17.7-103.3,74.9-73.2h.1c5.65-5.53,7.81-12.7,7.13-19.5h26.89c-2.4-5.2-4.6-10.6-6.5-16ZM385.06,208.39h96v32h16v-32h192v32h16v-32h96v96h-416v-96ZM549.15,616.29l-74.9,73.2c-3.8,3.7-5.5,9-4.6,14.1l17.7,103.4c1.1,6.5-5.7,11.5-11.6,8.4l-92.6-48.8c-4.7-2.5-10.2-2.5-14.9,0l-92.5,48.8c-5.9,3.1-12.7-1.9-11.6-8.4l17.6-103.3c.9-5.2-.8-10.5-4.6-14.1l-74.9-73.2c-4.7-4.6-2.1-12.7,4.4-13.6l103.6-15.2c5.2-.8,9.7-4,12-8.8l46.3-94c.15-.32.33-.61.52-.9v124.4h182.2c.81,2.67.24,5.74-2.11,8Z"
      />
      <polygon
        fill={fill}
        points="777.06 448.39 761.06 448.39 761.06 536.39 833.06 536.39 833.06 520.39 777.06 520.39 777.06 448.39"
      />
      <path
        fill={fill}
        d="M769.06,384.39c-79.5,0-144,64.5-144,144s64.5,144,144,144,144-64.5,144-144-64.5-144-144-144ZM769.06,656.39c-70.7,0-128-57.3-128-128s57.3-128,128-128,128,57.3,128,128-57.3,128-128,128Z"
      />
    </svg>
  );
};
export default BrightDateIcon;
